// @ts-nocheck

import { match as MatchStateUtils } from '..';
import { DefaultVisibleSetsNumbers } from '../../constants/scoreboards';
import { __ } from '../../i18n/l10n';
import type { ScoreboardProps, SecondariesScoreType } from '../../states/scoreboards';
import PeriodIds from '../../types/periodIds';

export const computeSecondaryScores = (scores: Array<string>): SecondariesScoreType => {
  const finalScores = [];

  scores.map((score) => {
    return finalScores.push({
      score: score.split(':'),
    });
  });

  return finalScores;
};

export default ({
  sportId,
  matchId,
  period,
  periodId,
  periodName,
  setScores,
  competitor1Name,
  competitor2Name,
  competitor1ShortName,
  competitor2ShortName,
  competitor1Flag,
  competitor2Flag,
  gameScore,
  isPrivateScore,
  server,
}: unknown): ScoreboardProps => {
  let scores = null;
  let gameScores = null;

  if (setScores && setScores !== '') {
    scores = setScores.split(' - ');
  }

  if (MatchStateUtils.isPrivateScore(sportId, isPrivateScore)) {
    gameScores = ['-', '-'];
  } else if (gameScore && gameScore !== '') {
    gameScores = gameScore.split(':');
  }

  return {
    matchId,
    period: periodName || MatchStateUtils.statusMatchBySport(sportId, period),
    competitors: [
      {
        name: scores && scores.length > 3 && competitor1ShortName ? competitor1ShortName : competitor1Name,
        flag: competitor1Flag,
        isServing: server === 1 && periodId !== PeriodIds.PERIOD_ID_ENDED,
      },
      {
        name: scores && scores.length > 3 && competitor1ShortName ? competitor2ShortName : competitor2Name,
        flag: competitor2Flag,
        isServing: server === 2 && periodId !== PeriodIds.PERIOD_ID_ENDED,
      },
    ],
    scores: {
      main: {
        label: __('!short:Points'),
        score: gameScores ? gameScores : ['', ''],
      },
      secondaries: scores ? computeSecondaryScores(scores) : [],
    },
    defaultVisibleSetsNumber: DefaultVisibleSetsNumbers.TENNIS,
  };
};
